import { hashStringToIndex } from '../../utils/stringUtils';

// Saturated counterparts of the tints the location monogram used. The monogram
// needed light backgrounds to keep its dark initials legible; a colour line
// carries no text, so it can use the colours at full strength.
const LOCATION_LINE_COLORS = [
  'var(--color-graphics-graph-first)',
  'var(--color-graphics-graph-second)',
  'var(--color-graphics-graph-third)'
] as const;

// A center's colour is derived from its name rather than configured anywhere, so
// the same center always reads the same colour with no stored state. Stable, not
// unique: with three colours, centers do collide.
export const getLocationLineColor = (locationName: string): string =>
  LOCATION_LINE_COLORS[hashStringToIndex(locationName, LOCATION_LINE_COLORS.length)];
